const OnboardP = ({ children, additionalClass }) => (
    <p className={`custom-text-grey-500  poppins-medium ${additionalClass}`}>{children}</p>
  );
  
  export default OnboardP;
  